import React, { PureComponent } from 'react';
import Mouse from 'core/mouse';
import styles from './resize-bar.scss';

interface ResizeBarProps {
  axis: 'x' | 'y';
  onResize: (deltaMove: number) => void;
}
export default class ResizeBar extends PureComponent<ResizeBarProps> {
  state = {
    dragging: false
  };

  prevPos: number = 0;

  get axis(): 'x' | 'y' {
    return this.props.axis || 'x';
  }

  pos(e: MouseEvent): number {
    return this.axis === 'x' ? e.pageX : e.pageY;
  }

  handleDragStart = (e: MouseEvent) => {
    this.prevPos = this.pos(e);
    this.setState({ dragging: true });
    Mouse.on('mousemove', this.handleDrag);
    Mouse.on('mouseup', this.handleDragEnd);
  };

  handleDrag = (e: MouseEvent) => {
    const newPos = this.pos(e);
    this.props.onResize(newPos - this.prevPos);
    this.prevPos = newPos;
  };

  handleDragEnd = () => {
    this.setState({ dragging: false });
    Mouse.off('mousemove', this.handleDrag);
    Mouse.off('mouseup', this.handleDragEnd);
  };

  render() {
    const { dragging } = this.state;
    let cl = styles.root + ' ' + styles[this.axis];
    if (dragging) cl += ' ' + styles.dragging;
    return (
      <div className={cl} onMouseDown={this.handleDragStart}>
        <div className={styles.handle} />
      </div>
    );
  }
}
